import React from "react";
import { withRouter } from "react-router-dom";
import Button from "components/UI/Button";
import Item from "../Item";

import axios from "axios";
import { API_URL, ERROR_HANDLE } from "config/constants";

import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";
import TimePicker from "components/TimePicker";

const style = {
  wrapper: {},
  editButton: {
    width: "231px",
    height: "67px",
    fontSize: "18px"
  },
  buttonWrapper: {
    display: "flex"
  },
  itemText: {
    fontSize: "20px",
    color: "#b5b5b6",
    margin: "0px"
  },
  itemsWrapper: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    padding: "15px 40px 5px 40px"
  },
  input: {
    padding: "10px 0px 0px 0px",
    fontSize: "20px",
    textAlign: "center",
    borderBottom: "1px solid #b5b5b6"
  },
  textareaNote: {
    margin: "25px",
    padding: "25px",
    height: "100px",
    width: "1000px",
    border: "2px dashed #c6c6c6",
    borderRadius: "40px",
    fontSize: "16px"
  },
  timeSelect: {
    container: (base, state) => ({
      ...base
    }),
    control: (base, state) => ({
      ...base,
      border: "none",
      borderBottom: "1px solid #b5b5b6",
      borderRadius: "0px",
      backgroundColor: "#fff",
      color: "#b5b5b6",
      fontSize: "16px"
    }),
    indicatorSeparator: (base, state) => ({
      ...base,
      display: "none"
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: "#000"
    }),
    menu: (base, state) => ({
      ...base,
      maxHeight: "150px",
      overflow: "hidden"
    }),
    singleValue: (base, state) => ({
      ...base,
      color: "#b5b5b6",
      fontSize: "18px"
    })
  },
  textarea: {
    border: "1px solid #b5b5b5",
    borderRadius: "40px",
    margin: "10px",
    resize: "none",
    height: "100px",
    padding: "15px",
    fontSize: "16px",
    width: "200px"
  }
};

class Edit extends React.Component {
  state = {
    email: this.props.gym.email,
    address: this.props.gym.address,
    phone: this.props.gym.phone,
    rate: this.props.gym.rate,
    working_hours_full: this.props.workinghours,
    location: "",
    time_note: this.props.time_note
  };
  days = [
    { label: "SUN", value: 0 },
    { label: "MON", value: 1 },
    { label: "TUE", value: 2 },
    { label: "WED", value: 3 },
    { label: "THU", value: 4 },
    { label: "FRI", value: 5 },
    { label: "SAT", value: 6 }
  ];
  change(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  changeTime = (day, type, value) => {
    let { working_hours_full } = this.state;
    if (type === "start") {
      working_hours_full[day].start_time = value;
    } else {
      working_hours_full[day].end_time = value;
    }
    this.setState({ working_hours_full });
  };
  updateDay = day => {
    this.setState({
      day: day.value
    });
  };

  timeConverter = time => {
    let hh = parseInt(time.split(":")[0], 10);
    let mm = time.split(":")[1];
    if (parseInt(time.split(":").join(""), 10) >= 1200) {
      hh %= 12;
      if (hh === 0) {
        hh = 12;
      }
      return `${hh}:${mm} PM`;
    } else {
      if (hh === 0) {
        hh = 12;
      }
      return `${hh}:${mm} AM`;
    }
  };

  // time2RailwayTime = time => {
  //   let hh = time.split(':')[0];
  //   let mm = time.split;
  // };

  // selectGyms = selectedItems => {
  //   let filterGyms = selectedItems.map(gym => gym.value);
  //   this.setState({
  //     ...this.state,
  //     gyms: filterGyms
  //   });
  // };
  updateFacilities = () => {
    const access_token = localStorage.getItem("access_token");
    const gymid = this.props.gymid;
    let {
      email,
      address,
      phone,
      working_hours_full,
      start,
      end,
      rate,
      time_note
    } = this.state;

    const data = {
      email,
      address,
      start_time: start,
      end_time: end,
      working_hours: working_hours_full,
      phone,
      rate,
      time_note
    };
    axios
      .put(`${API_URL}/admin/gyms/${gymid}`, data, {
        headers: {
          "x-access-token": access_token
        }
      })

      .then(res => {
        console.log("Facilities Saved");
        this.props.updateGym(gymid);
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  };
  // componentDidMount() {
  //   const { hours } = this.props;
  //   if (hours) {
  //     const start = hours['start'];
  //     const end = hours['end'];
  //     this.setState({ start, end });
  //   }
  // }

  handleChange = address => {
    this.setState({
      address
    });
  };
  handleSelect = address => {
    this.setState({ address });
    geocodeByAddress(address)
      .then(res => getLatLng(res[0]))
      .then(position => {
        this.setState({
          location: `${position.lat},${position.lng}`
        });
      })
      .catch(error => {
        console.log("error", error);
      });
  };

  handleError = (status, clearSuggestions) => {
    console.log("Error from Google Maps API", status);
    this.setState({ errorMessage: status }, () => {
      clearSuggestions();
    });
  };
  render() {
    const { email, address, phone, working_hours_full, rate } = this.state;
    return (
      <div style={style.wrapper}>
        <div style={style.buttonWrapper}>
          <SaveButton onClick={()=>{
            this.props.gym.email = email;
            this.props.gym.address = address;
            this.props.gym.rate = rate;
            this.props.gym.phone = phone;
            this.updateFacilities();
          }}/>
        </div>
        <div style={style.itemsWrapper}>
          <Item imageName="place-white-blue.png" label="Place">
            <PlacesAutocomplete
              onChange={this.handleChange}
              value={address}
              onSelect={this.handleSelect}
              onError={this.handleError}
              shouldFetchSuggestions={address && address.length > 1}
            >
              {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                <div>
                  <input
                    style={{ ...style.input, width: "280px" }}
                    {...getInputProps()}
                  />
                  {suggestions.length > 0 && (
                    <div
                      style={{
                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                      }}
                    >
                      {suggestions.map(suggestion => (
                        <div
                          {...getSuggestionItemProps(suggestion)}
                          style={
                            suggestion.active
                              ? {
                                backgroundColor: "var(--primary)",
                                padding: "16px 15px",
                                transition: "padding .1s",
                                color: "white"
                              }
                              : {
                                padding: "5px 10px",
                                transition: "padding .1s"
                              }
                          }
                        >
                          <strong>
                            {suggestion.formattedSuggestion.mainText}
                          </strong>{" "}
                          <small>
                            {suggestion.formattedSuggestion.secondaryText}
                          </small>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </PlacesAutocomplete>
          </Item>

          <Item imageName="email-icon.png" label="Email">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <input
                style={{ ...style.input }}
                type="email"
                name="email"
                value={email}
                onChange={this.change.bind(this)}
              />
            </div>
          </Item>
          <Item imageName="contact-white-blue.png" label="Contact">
            <input
              style={{ ...style.input, width: "200px" }}
              type="text"
              value={phone}
              name="phone"
              maxLength="14"
              onChange={this.change.bind(this)}
            />
          </Item>
          <Item imageName="dollar-white-blue.png" label="Rate">
            <input
              value={rate}
              style={{ ...style.input, textAlign: "center" }}
              type="text"
              name="rate"
              maxLength="5"
              onChange={this.change.bind(this)}
            />
            <p style={style.itemText}>$/min</p>
          </Item>
        </div>
        {working_hours_full && (
          <div>
            <h1>GYM HOURS</h1>
            <div style={style.itemsWrapper}>
              <Item label="SUN">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <TimePicker
                    day="sun"
                    type="start"
                    changeTime={this.changeTime}
                    currentTime={
                      this.state.working_hours_full["sun"]
                        ? this.state.working_hours_full["sun"].start_time
                        : "12:00 AM"
                    }
                  />
                  <TimePicker
                    day="sun"
                    type="end"
                    changeTime={this.changeTime}
                    currentTime={
                      this.state.working_hours_full["sun"]
                        ? this.state.working_hours_full["sun"].end_time
                        : "12:00 AM"
                    }
                  />
                  {/* <input
                    style={{ ...style.input }}
                    type="time"
                    name="sunstart"
                    value={working_hours_full["sun"].start_time}
                    onChange={this.changeTime.bind(this)}
                  />

                  <input
                    style={{ ...style.input }}
                    type="time"
                    name="sunend"
                    value={working_hours_full["sun"].end_time}
                    onChange={this.changeTime.bind(this)}
                  /> */}
                </div>
              </Item>

              <Item label="MON">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <TimePicker
                    day="mon"
                    type="start"
                    changeTime={this.changeTime}
                    currentTime={
                      this.state.working_hours_full["mon"]
                        ? this.state.working_hours_full["mon"].start_time
                        : "12:00 AM"
                    }
                  />
                  <TimePicker
                    day="mon"
                    type="end"
                    changeTime={this.changeTime}
                    currentTime={
                      this.state.working_hours_full["mon"]
                        ? this.state.working_hours_full["mon"].end_time
                        : "12:00 AM"
                    }
                  />
                  {/* <input
                    style={{ ...style.input }}
                    type="time"
                    name="monstart"
                    value={working_hours_full["mon"].start_time}
                    onChange={this.changeTime.bind(this)}
                  />
                  <input
                    style={{ ...style.input }}
                    type="time"
                    name="monend"
                    value={working_hours_full["mon"].end_time}
                    onChange={this.changeTime.bind(this)}
                  /> */}
                </div>
              </Item>
              <Item label="TUE">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  {" "}
                  <TimePicker
                    day="tue"
                    type="start"
                    changeTime={this.changeTime}
                    currentTime={
                      this.state.working_hours_full["tue"]
                        ? this.state.working_hours_full["tue"].start_time
                        : "12:00 AM"
                    }
                  />
                  <TimePicker
                    day="tue"
                    type="end"
                    changeTime={this.changeTime}
                    currentTime={
                      this.state.working_hours_full["tue"]
                        ? this.state.working_hours_full["tue"].end_time
                        : "12:00 AM"
                    }
                  />
                  {/* <input
                    style={{ ...style.input }}
                    type="time"
                    name="tuestart"
                    value={working_hours_full["tue"].start_time}
                    onChange={this.changeTime.bind(this)}
                  />
                  <input
                    style={{ ...style.input }}
                    type="time"
                    name="tueend"
                    value={working_hours_full["tue"].end_time}
                    onChange={this.changeTime.bind(this)}
                  /> */}
                </div>
              </Item>
              <Item label="WED">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <TimePicker
                    day="wed"
                    type="start"
                    changeTime={this.changeTime}
                    currentTime={
                      this.state.working_hours_full["wed"]
                        ? this.state.working_hours_full["wed"].start_time
                        : "12:00 AM"
                    }
                  />
                  <TimePicker
                    day="wed"
                    type="end"
                    changeTime={this.changeTime}
                    currentTime={
                      this.state.working_hours_full["wed"]
                        ? this.state.working_hours_full["wed"].end_time
                        : "12:00 AM"
                    }
                  />
                  {/* <input
                    style={{ ...style.input }}
                    type="time"
                    name="wedstart"
                    value={working_hours_full["wed"].start_time}
                    onChange={this.changeTime.bind(this)}
                  />
                  <input
                    style={{ ...style.input }}
                    type="time"
                    name="wedend"
                    value={working_hours_full["wed"].end_time}
                    onChange={this.changeTime.bind(this)}
                  /> */}
                </div>
              </Item>
              <Item label="THU">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <TimePicker
                    day="thu"
                    type="start"
                    changeTime={this.changeTime}
                    currentTime={
                      this.state.working_hours_full["thu"]
                        ? this.state.working_hours_full["thu"].start_time
                        : "12:00 AM"
                    }
                  />
                  <TimePicker
                    day="thu"
                    type="end"
                    changeTime={this.changeTime}
                    currentTime={
                      this.state.working_hours_full["thu"]
                        ? this.state.working_hours_full["thu"].end_time
                        : "12:00 AM"
                    }
                  />
                  {/* <input
                    style={{ ...style.input }}
                    type="time"
                    name="thustart"
                    value={working_hours_full["thu"].start_time}
                    onChange={this.changeTime.bind(this)}
                  />
                  <input
                    style={{ ...style.input }}
                    type="time"
                    name="thuend"
                    value={working_hours_full["thu"].end_time}
                    onChange={this.changeTime.bind(this)}
                  /> */}
                </div>
              </Item>
              <Item label="FRI">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  {" "}
                  <TimePicker
                    day="fri"
                    type="start"
                    changeTime={this.changeTime}
                    currentTime={
                      this.state.working_hours_full["fri"]
                        ? this.state.working_hours_full["fri"].start_time
                        : "12:00 AM"
                    }
                  />
                  <TimePicker
                    day="fri"
                    type="end"
                    changeTime={this.changeTime}
                    currentTime={
                      this.state.working_hours_full["fri"]
                        ? this.state.working_hours_full["fri"].end_time
                        : "12:00 AM"
                    }
                  />
                  {/* <input
                    style={{ ...style.input }}
                    type="time"
                    name="fristart"
                    value={working_hours_full["fri"].start_time}
                    onChange={this.changeTime.bind(this)}
                  />
                  <input
                    style={{ ...style.input }}
                    type="time"
                    name="friend"
                    value={working_hours_full["fri"].end_time}
                    onChange={this.changeTime.bind(this)}
                  /> */}
                </div>
              </Item>
              <Item label="SAT">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <TimePicker
                    day="sat"
                    type="start"
                    changeTime={this.changeTime}
                    currentTime={
                      this.state.working_hours_full["sat"]
                        ? this.state.working_hours_full["sat"].start_time
                        : "12:00 AM"
                    }
                  />
                  <TimePicker
                    day="sat"
                    type="end"
                    changeTime={this.changeTime}
                    currentTime={
                      this.state.working_hours_full["sat"]
                        ? this.state.working_hours_full["sat"].end_time
                        : "12:00 AM"
                    }
                  />
                  {/* <input
                    style={{ ...style.input }}
                    type="time"
                    name="satstart"
                    value={working_hours_full["sat"].start_time}
                    onChange={this.changeTime.bind(this)}
                  />
                  <input
                    style={{ ...style.input }}
                    type="time"
                    name="satend"
                    value={working_hours_full["sat"].end_time}
                    onChange={this.changeTime.bind(this)}
                  /> */}
                </div>
              </Item>
            </div>
          </div>
        )}

        {/* <div>
          <h1>GYM HOURS</h1>
          <div style={style.itemsWrapper}>
            <Item
              label={
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <span style={{ padding: '0em 1em' }}>
                    Set Start and End Time for:
                  </span>
                  <div style={{ width: '10%' }}>
                    <Select
                      styles={{ width: '50%' }}
                      defaultValue={this.days[this.state.day]}
                      options={this.days}
                      onChange={this.updateDay}
                    />
                  </div>
                </div>
              }
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <input
                  style={{ ...style.input }}
                  type="time"
                  name="start"
                  value={start}
                  onChange={this.change.bind(this)}
                />
                <input
                  style={{ ...style.input }}
                  type="time"
                  name="end"
                  value={end}
                  onChange={this.change.bind(this)}
                />
              </div>
            </Item>
          </div>
        </div> */}
        <div>
          <h1>NOTES</h1>
          <div style={style.itemsWrapper}>
            <textarea
              style={style.textareaNote}
              onChange={e => {
                this.setState({ ...this.state, time_note: e.target.value });
                console.log(e.target.value);
              }}
              value={this.state.time_note}
            />
          </div>
        </div>
      </div>
    );
  }
}

const SaveButton = withRouter((props)=> {
  return (
    <Button type="primary" style={style.editButton}
      onClick={()=>{
        props.history.goBack()
        props.onClick();
      }}>
      Save
    </Button>
  )
})

export default Edit;
